import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useEffect } from 'react';

const ScheduleStep = ({ stepKey, updateStepData, getStepData }) => {
    const stepData = getStepData(stepKey);

    useEffect(() => {
        if (stepData.interval) {
            updateStepData(stepKey, stepData);
        }
    }, []);

    const handleInputChange = (value) => {
        const newData = { ...stepData, interval: value };
        updateStepData(stepKey, newData);
    };

    return (
        <div className="flex flex-col space-y-8 items-center">
            <div className="flex flex-col items-center space-y-3">
                <h1 className="font-semibold text-3xl text-center">Schedule</h1>
                <p className="text-center text-muted-foreground">Set how often you want to run this monitor</p>
            </div>
            <div className="w-full max-w-lg mx-auto space-y-4">
                <div className="flex flex-col space-y-3">
                    <Label htmlFor="interval">Check interval</Label>
                    <Select 
                        onValueChange={handleInputChange} 
                        defaultValue={stepData.interval.toString()}
                    >
                        <SelectTrigger>
                            <SelectValue placeholder="Select interval" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="1">Every 1 minute</SelectItem>
                            <SelectItem value="5">Every 5 minutes</SelectItem>
                            <SelectItem value="15">Every 15 minutes</SelectItem>
                            <SelectItem value="30">Every 30 minutes</SelectItem>
                            <SelectItem value="60">Every 1 hour</SelectItem>
                        </SelectContent>
                    </Select>
                </div>
            </div>
        </div>
    );
};

export default ScheduleStep;
